import { find, includes } from 'lodash';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router';

import type { AuthUser } from 'common/auth/types';
import { UserSubType } from 'common/graphql/types';
import { CILogger } from 'common/log/log.provider';
import { CIPageStatus } from 'common/viewcomp/general/ci_pagestatus';

import { useUpdateActiveStudySiteWithRole } from './useUpdateActiveStudySiteWithRole';

// TODO: should be a wrapper instead ? It's possible other navigation happens before this
// finishes the load
const useStudySiteQueryParamUpdate = (activeUser?: AuthUser) => {
    const location = useLocation();
    const history = useHistory();
    const { t } = useTranslation('global');
    const [updateActiveStudySite] = useUpdateActiveStudySiteWithRole();
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const studyId = queryParams.get('studyId');
        const siteId = queryParams.get('siteId');

        const study =
            studyId && activeUser?.userStudies ? find(activeUser.userStudies, ['studyId', studyId]) : undefined;
        const site = siteId && study ? find(study?.userStudySites, ['siteId', siteId]) : undefined;

        if (
            includes(
                [
                    UserSubType.SITE,
                    UserSubType.MONITOR,
                    UserSubType.DATA_MANAGER,
                    UserSubType.INSPECTOR,
                    UserSubType.PRODUCT_SUPPORT,
                    UserSubType.DATA_CHANGE_SUPPORT,
                ],
                activeUser?.subType as UserSubType
            ) &&
            study &&
            site
        ) {
            // Note: Url is handled differently later in the process if the study or site is not found.
            setLoading(true);
            updateActiveStudySite({ study, site })
                .then(() => {
                    queryParams.delete('studyId');
                    queryParams.delete('siteId');
                    const newSearch = queryParams.toString();
                    history.replace({
                        pathname: location.pathname,
                        search: newSearch.length > 0 ? `?${newSearch}` : '',
                    });
                })
                .catch((e) => {
                    CIPageStatus.error(t('switch_role.errors.updating_active_study_site'));
                    CILogger.getInstance().error(t('switch_role.errors.updating_active_study_site'), e);
                })
                .finally(() => setLoading(false));
        } else {
            setLoading(false);
        }
    }, [location.search]);

    return { loading };
};

export default useStudySiteQueryParamUpdate;
